import { Injectable } from '@angular/core';
import { AppState } from '../../app.state';
import { Store } from '@ngrx/store';
import * as RouterActions from '../actions/router.actions';
import * as app from '../../app.selector';
import * as applications from '../../modules/applications/application.selector';
import * as card from '../../modules/card/card.selector';
import * as history from '../../modules/history-requests/history-requests.selector';
import * as consent from '../../modules/consent/consent.selector';
import { Observable } from 'rxjs/Observable';

import 'rxjs/add/observable/merge';
import 'rxjs/add/operator/filter';
import 'rxjs/add/operator/map';
import 'rxjs/add/operator/do';


/**
 * Effect to redirect to error page.
 *
 *  {
 *      "[Applications] Load Error": {
 *          "headers": {
 *              "normalizedNames": [],
 *              "lazyUpdate": null
 *          },
 *          "status": 500,
 *          "statusText": "Internal Server Error",
 *          "url": "http://localhost:3000/psd2-self-service/my/apps?page=0&size=4&sort=name&order=asc&active=true",
 *          "ok": false,
 *          "name": "HttpErrorResponse",
 *          "message": "Http failure response for http://localhost:3000/psd2-self-service/my/apps?page=0&size=4",
 *          "error": {
 *              "errors": [
 *                  {
 *                      "errorType": "RECORD_DOES_NOT_EXIST",
 *                      "scope": "Record does not exist, Record does not exist",
 *                      "parameters": []
 *                  }
 *              ]
 *          }
 *      }
 *  }
 */
@Injectable()
export class ErrorEffect {

    constructor(private store: Store<AppState>) {
        Observable.merge(
            this.store.select(app.selectLoadingError),
            this.store.select(applications.selectLoadingError),
            this.store.select(card.selectLoadingError),
            this.store.select(history.selectLoadingError),
            this.store.select(consent.selectLoadingError))
            .filter(error => !!error)
            .map(error => Object.keys(error).map((k) => error[k]))
            .filter(errorArr => !!errorArr.length)
            .subscribe((errorArr) => {

                errorArr.every(console.error.bind(console));

                if (errorArr.some(e => ((<any>e).status === 401  ||  (<any>e).status === 403))) {
                    this.store.dispatch(
                        new RouterActions.Go({
                            path: ['expired']
                        }));
                } else {
                    this.store.dispatch(
                        new RouterActions.Go({
                            path: ['500']
                        }));
                }

            });
    }
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/@angularclass/hmr-loader!./~/angular-router-loader/src!./~/tslint-loader!./src/app/core/effects/error.effect.ts